import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/quoting_/squawks/edit/$squawkId",
)({
  beforeLoad: ({ params: { squawkId } }) => {
    throw redirect({
      to: "/quoting/squawks/$squawkId",
      params: { squawkId },
      search: true,
    })
  },
})
